import React, { useEffect } from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import { useNavigate } from "@reach/router"
import Layout from '../layout/Layout'
import CreditIcon from '../../components/CreditIcon'
import Radio from '@mui/material/Radio';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';
import LoadingButton from '@mui/lab/LoadingButton';
import {ReactComponent as PaypalIcon} from '../../images/paypal.svg'
import classes from './Checkout.module.scss'
import subscribeStore from './subscribeStore'
import { runInAction } from 'mobx'
import Link from '@mui/material/Link'
import SubSuccessModal from './SubSuccessModal'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress'
import userStore from '../common/userStore'
import {redeemCreditOrder} from './AccountAPI'


const TrialInfo = observer(({checkoutPlan}) => {

  return <div className={classes.info}>
    <h3>Automatic Renewal Terms</h3>
    <div className={classes.infoDetail}>
    By clicking “Start subscription”, your 14-day free trial will start immediately. 
    After your trial ends, you will be charged 
    <span className={classes.bold}> ${checkoutPlan.price} </span>  per 
    <span className={classes.bold}> {checkoutPlan.type == 0 ? 'month' : 'year'} </span>
    , plus applicable taxes. Your subscription will continue, and your payment account 
    will be charged automatically, each month until you cancel. The amount of this charge may change if you 
    change your plan selection or if we change our pricing (with notice to you). If you cancel during the trial period, 
    you will not be charged. You can cancel any time online using your account settings. Cancellation after the trial 
    period will take effect at the beginning of the next renewal term. 
      </div>
  </div>
})

const ChangeInfo = observer(({checkoutPlan}) => {
  const navigate = useNavigate();

  return <div className={classes.info}>
    <h3>Automatic Renewal Terms</h3>
    <div className={classes.infoDetail}>
    By clicking “Start subscription”, you will be charged  
    <span className={classes.bold}> ${checkoutPlan.price} </span>  per 
    <span className={classes.bold}> {checkoutPlan.type == 0 ? 'month' : 'year'} </span>
    , plus applicable taxes, until you cancel. 
  You can cancel at any time in your account settings. If you cancel, you still may be charged for the current 
  billing period. More information can be found at our 
      <Link href="/policies/terms-of-service" onClick={(e) => {
        e.preventDefault()
        navigate('/policies/terms-of-service')
      }}>Terms of Service</Link>
      . By clicking “Start subscription”, you 
  acknowledge that you understand and agree to these terms.
      </div>
  </div>
})


const features = "height=500, width=800, toolbar=no, menubar=no, scrollbars=no,resizable=no, location=no, status=no";

const Checkout = observer(({location}) => {
  const { hideSubPlan, loadPlans, createSub, changePlan, subStatusCheck, fetchSub, loadSub, currentSub, reloadSubStatus } = subscribeStore;
  const navigate = useNavigate();

  useEffect(() => {
    window.gtag('event', 'conversion', {'send_to': 'AW-10846025106/hXI2CJ673JsDEJLr5LMo'});
    }, [])

  const model = useLocalObservable(() => ({
    // timeout: null,
    createding: false,
    // 当前选中 plan
    checkoutPlan: null,
    // 支付中的订阅
    payingSub: null,
    // 弹窗
    payingWin: null,
    // 
    currentSub: null,
    // 
    status: null,
    error: false,
    success: false,
    redeeming: false,
    redeemFail: false,
    get isOpenWin() {
      return this.payingSub != null && !this.success
    },
    redeemOrder: async () => {
      model.redeeming = true
      try {
          const rs = await redeemCreditOrder({code: document.getElementsByName("redeem-code")[0].value.trim()});
          model.redeeming = false
          if (rs.code == 0)
            model.success = true
          else
          {
            model.redeemFail = true;
            console.log(rs)
          }
      } catch (e) {
          model.redeeming = false;
          model.redeemFail = true;
          console.log(e)
          throw e;
      }
  },
    setCreateding(bool) {
      this.createding = bool
    },
    async checkStatus() {
      if (this.payingWin && this.payingWin.closed) {
        try {
          const rs = await fetchSub()
          const newSub = rs.subscription;
          const oldSub = this.currentSub && this.currentSub.subscription
          if (newSub.status == 'ACTIVE' && (!oldSub || oldSub.status != 'ACTIVE' || oldSub.plan_id != newSub.plan_id)) {
            window.fpr("referral",{email: userStore.user.email})
            this.setSuccess(true)
            await reloadSubStatus()
            return;
          }
          runInAction(() => this.error = true)
        } catch (e) {
          runInAction(() => this.error = true)
        } finally {
          runInAction(() => {
            this.payingSub = null
            this.payingWin = null
          })
        }
        return
      }
      setTimeout(this.checkStatus, 300);
    },
    async createSubscribe() {
      try {
        this.setCreateding(true)
        this.payingWin = window.open('about:blank', '_blank', features)
        const action = (this.status.isActive || this.status.isTrial) ? changePlan : createSub
        let rs = await action(this.checkoutPlan.planId)
        //console.log(rs, this.payingWin)
        runInAction(() => {
          this.payingSub = rs
          this.payingWin.location.href = rs.links[0].href
          setTimeout(this.checkStatus, 500);
        })
      } catch (e) {
        console.error(e)
        runInAction(() => {
          this.payingWin && this.payingWin.close()
        })
      } finally {
        this.setCreateding(false)
      }
    },
    back() {
      //navigate(-1)
      navigate('/', {replace:true})
    },
    setStatus(status) {
      this.status = status
    },
    async setPlan(id) {
      const plans = await loadPlans()
      this.checkoutPlan = plans.find(plan => plan.id == id) || null
    },
    setCurrentSub(sub) {
      this.currentSub = sub
    },
    setSuccess(s) {
      this.success = s
    },
    redeem: () => {
      model.redeemOrder()
    },
    close() {
      if (this.payingWin) {
        this.payingWin.close();
      }
      // console.log(this.payingWin)
      //this.checkStatus()
    }
  }))

  useEffect(() => {
    model.setStatus(subStatusCheck)
    model.setCurrentSub(currentSub)
  }, [subStatusCheck, currentSub, model])

  useEffect(() => {
    hideSubPlan()
    const params = new URLSearchParams(location.search)
    model.setPlan(params.get('plan-id'))
  }, [location, model])

  useEffect(() => {
    loadSub()
  }, [loadSub])

  const checkoutPlan = model.checkoutPlan

  if (!checkoutPlan) {
    return <Layout></Layout>
  }

  //model.isOpenWin
  return <Layout>
    <SubSuccessModal open={model.success} />
    <Backdrop open={model.isOpenWin} style={{zIndex: 10000}} className={classes.waiting}>
      <CircularProgress />
      <p>Please do not close this page. You will be automatically redirected to home after complete</p>
      <Button variant="contained" disableElevation className={classes.waitingClose} onClick={model.close}>I've made the payment</Button>
    </Backdrop>
    <div className={classes.root}>
      <div className={classes.content}>
        <h1>Checkout</h1>
        <div className={classes.plan}>
          <div className={classes.icon}><CreditIcon size={40} /></div>
          <div className={classes.desc}>
          {checkoutPlan.name} <br />
          {checkoutPlan.credit} {checkoutPlan.type == 0 ? 'monthly' : 'yearly'} credits
          </div>
          <div className={classes.price}> ${checkoutPlan.price}/{checkoutPlan.type == 0 ? 'mo' : 'yr'} </div>
        </div>
        <div className={classes.detail}>
          <div className={classes.item}>
            <div className={classes.left}>Subtotal</div>
            <div className={classes.right}>${checkoutPlan.price}/{checkoutPlan.type == 0 ? 'mo' : 'yr'}</div>
          </div>
          <div className={classes.item}>
            <div className={classes.left}>Tax</div>
            <div className={classes.right}>$0.00</div>
          </div>
          <div className={classes.line}></div>
          <div className={classes.item}>
            <div className={classes.left}>Total</div>
            <div className={classes.right}>${checkoutPlan.price}</div>
          </div>
        </div>
        <div className={classes.tips}>
        {subStatusCheck.isNew && 'You will only be charged after 14 days'}
        </div>
        <div className={classes.redeem}>
            <div className={classes.redeemTitle}>Enter a redeem or promotional code</div>
            <div className={classes.actions} style={{margin:0, justifyContent: 'flex-start'}}>
                <OutlinedInput id="redeem-code" name="redeem-code" style={{marginRight: 10}} autoComplete="off" size="small" placeholder="Enter Code" />
                <LoadingButton
                    className={classes.action}
                    variant="contained"
                    disableElevation
                    loading={model.redeeming}
                    onClick={model.redeem}
                >Apply</LoadingButton>
            </div>
            {model.redeemFail && <div className={classes.error}>
                <ErrorOutlineIcon size="small" />
                {/* state.redeemErrorMsg */}
                Invalid code, please try another
            </div>}
        </div>
        <div className={classes.methods}>
          <h2>Payment method</h2>
          <div className={classes.items}>
            <label className={classes.item}>
              <Radio checked={true} value="paypal" size="small" />
              <PaypalIcon className={classes.paypal} />
            </label>
          </div>
        </div>

        {model.error && <div className={classes.error}>
            <ErrorOutlineIcon size="small" />
            Prease review your billing information or try another payment method
        </div>}

        {subStatusCheck.isNew ? <TrialInfo checkoutPlan={checkoutPlan} /> : <ChangeInfo checkoutPlan={checkoutPlan} />}

        <div className={classes.actions}>
          <Button 
            variant="outlined" 
            className={classes.action} onClick={model.back}>Not now</Button>
          <LoadingButton 
            className={classes.action}
            variant="contained" 
            disableElevation
            loading={model.createding}
            onClick={model.createSubscribe}
            >Start subscription</LoadingButton>
        </div>
      </div>
    </div>
  </Layout>
})

export default Checkout;